import SuperICDandCPTSearch from '../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch'
import isNull from '../../utils/NullChecking'
import { FindFirstChild } from '../../utils/FindMenuOption'
import { useSelector } from 'react-redux'
import NotificationHandler from '../../utils/NotificationHandler'
import AddNewModifier from '../Setup/Coding/Modifiers/AddNewModifier'
import AddNewProcedureCodes from '../Setup/Coding/ProcedureCode/AddNewProcedureCodes'
import { useEffect, useState } from 'react'
import { enumUtil } from '../../utils/Enum'
import { ServerRequestProtected } from '../../utils/ServerDataRequest'

const AddNewCPTAppointment = ({ mainAppointmentModal, handleAppointmentClose, handleAppointment, ProcedureCodeData, setProcedureCodeData, PatientAppointmentID }) => {
    const API_URL_Claim = enumUtil.controller.Claim
    const API_URL_General = enumUtil.controller.General
    let IsEditAllowed = FindFirstChild('Scheduler', 'Appointment')?.IsAdd
    let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)
    let RecentModifiers = useSelector(state => state.CodesDropDownReducer.RecentModifier)
    let linkProcedureCodeModal = {
        PatientAppointmentProcedureCodeID: '',
        ProcedureCode: '',
        ProcedureCodeID: '',
        Amount: '',
        Units: '',
        ModifierCode1: '',
        ModifierCode2: '',
        ModifierCode3: '',
        ModifierCode4: '',
        ModifierCode1ID: '',
        ModifierCode2ID: '',
        ModifierCode3ID: '',
        ModifierCode4ID: '',
        isDeleted: 'false'
    }
    const [modifierBody, setmodifierBody] = useState({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": '' })
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })
    const [ProcedureCode, setProcedureCode] = useState('')
    // const [ProcedureCodeData, setProcedureCodeData] = useState([])
    const handleChangeProcedureCode = (e) => {
        setProcedureCode(e.target.value)
        setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": e.target.value })
    }
    const getCPTAmount = (selectedData) => {
        ServerRequestProtected(API_URL_General + "/FindByID", 'post', {
            "ID": selectedData.value + "",
            "TableName": enumUtil.enumAPITableName.AppointmentTypeProcedureCode
        }).then((response) => {
            setProcedureCodeData(prev => ([
                ...prev,
                {
                    ...linkProcedureCodeModal,
                    ProcedureCode: selectedData.display,
                    ProcedureCodeID: selectedData.value + "",
                    Amount: !isNull(response.Amount) ? response.Amount + "" : '',
                    Units: '1',
                    ModifierCode1: !isNull(response.DefaultModifierCode1) ? response.DefaultModifierCode1 : '',
                    ModifierCode2: !isNull(response.DefaultModifierCode2) ? response.DefaultModifierCode2 : '',
                    ModifierCode3: !isNull(response.DefaultModifierCode3) ? response.DefaultModifierCode3 : '',
                    ModifierCode4: !isNull(response.DefaultModifierCode4) ? response.DefaultModifierCode4 : '',
                    ModifierCode1ID: !isNull(response.DefaultModifierCodeID1) ? response.DefaultModifierCodeID1 + "" : '',
                    ModifierCode2ID: !isNull(response.DefaultModifierCodeID2) ? response.DefaultModifierCodeID2 + "" : '',
                    ModifierCode3ID: !isNull(response.DefaultModifierCodeID3) ? response.DefaultModifierCodeID3 + "" : '',
                    ModifierCode4ID: !isNull(response.DefaultModifierCodeID4) ? response.DefaultModifierCodeID4 + "" : '',
                }
            ]));
        }).catch((error) => {
            setProcedureCodeData(prev => ([
                ...prev,
                {
                    ...linkProcedureCodeModal,
                    ProcedureCode: selectedData.display,
                    ProcedureCodeID: selectedData.value + "",
                    Units: '1',
                }
            ]));
        })
    }
    const handleSelectData = (selectedData, name, type) => {
        if (type === 'server' && !isNull(selectedData) && name === 'ProcedureCode') {
            const alreadyExists = ProcedureCodeData.some(
                x => x.isDeleted !== 'true' && x.ProcedureCodeID + "" === selectedData.value + ""
            );
            if (alreadyExists) {
                NotificationHandler('This CPT is already added', enumUtil.enumtoaster.error);
                setProcedureCode('');
                return;
            }
            // setProcedureCodeData(prev => ([
            //     ...prev,
            //     {
            //         ...linkProcedureCodeModal,
            //         ProcedureCode: selectedData.display,
            //         ProcedureCodeID: selectedData.value + "",
            //     }
            // ]));
            getCPTAmount(selectedData)
            setProcedureCode('');
        }
    };
    const handleChangeLinkData = (e, index) => {
        const { value, name } = e.target;
        if (name !== 'Amount') {
            setmodifierBody({ TableName: enumUtil.enumAPITableName.Modifier, SearchParam: value });
        }
        setProcedureCodeData(prev => {
            const copy = [...prev];
            copy[index] = { ...copy[index], [name]: value };
            return copy;
        });
    };
    const handleSelectLinkData = (selectedData, name, type, index) => {
        if (type === 'server' && !isNull(selectedData)) {
            setProcedureCodeData(prev => {
                const copy = [...prev];
                copy[index] = {
                    ...copy[index],
                    [name]: selectedData.display,
                    [`${name}ID`]: selectedData.value + ""
                };
                return copy;
            });
        }
    };
    const handleDeleteProcedureRow = (index) => {
        let data = [...ProcedureCodeData]
        data[index]['isDeleted'] = 'true'
        setProcedureCodeData(data);
    };

    const handleSaveCPTAppointment = () => {
        console.log('ProcedureCodeData', ProcedureCodeData);
        // if (ProcedureCodeData.length === 0) {
        //     NotificationHandler('cannot save empty data in p', enumUtil.enumtoaster.error)
        // } else {
        handleAppointment('appointment', ProcedureCodeData)
        // }
    }
    //
    const [isOpenProcedure, setisOpenProcedure] = useState(false)
    const [isOpenModifierNew, setisOpenModifierNew] = useState(false)
    const [ActiveCode, setActiveCode] = useState('')
    const [ActiveCodeindex, setActiveCodeindex] = useState('')
    const [ActiveCodeName, setActiveCodeName] = useState('')
    const handleAddNewCPT = (searchValue) => {
        if (!isNull(searchValue)) {
            setActiveCode(searchValue)
        } else {
            setActiveCode('')
        }
        setisOpenProcedure(true)
    }
    const handleCloseCPT = () => {
        setisOpenProcedure(false)
        setActiveCode('')
    }
    const handleOnSaveICD = (selectedData) => {
        handleSelectData(selectedData, 'ProcedureCode', 'server')
        handleCloseCPT()
    }
    let ProcedurePopup = ''
    if (isOpenProcedure) {
        ProcedurePopup = <AddNewProcedureCodes isOpenProcedure={isOpenProcedure} onClose={handleCloseCPT} ProcedureCode={ActiveCode} onDeleteProcedure={handleCloseCPT} handleOnSaveICD={handleOnSaveICD} isOpenFromList={true} />
    }

    const handleAddNewModifier = (searchvalue, name, index) => {
        if (!isNull(searchvalue) && !isNull(name)) {
            setActiveCode(searchvalue)
            setActiveCodeName(name)
            setActiveCodeindex(index)
        } else {
            setActiveCode('')
        }
        setisOpenModifierNew(true)

    }
    const handleCloseModifier = () => {
        setisOpenModifierNew(false)
        setActiveCode('')
        setActiveCodeindex()
        setActiveCodeName('')
    }
    const handleSelectModofier = (selectedData) => {
        handleSelectLinkData(selectedData, ActiveCodeName, 'server', ActiveCodeindex)
        handleCloseModifier()
    }
    let ModifierPopup = ''
    if (isOpenModifierNew) {
        ModifierPopup = <AddNewModifier isOpenModifier={isOpenModifierNew} onClose={handleCloseModifier} ModifierCode={ActiveCode} onDeleteModifier={handleCloseModifier} isOpenFromList={true} handleSelectModofier={handleSelectModofier} />
    }

    // useEffect(() => {
    //     if (!isNull(ProcedureCodeData)) {
    //         setProcedureCodeData(ProcedureCodeData)
    //     }
    // }, [ProcedureCodeData])
    useEffect(() => {
        if (!isNull(PatientAppointmentID)) {
            ServerRequestProtected(API_URL_General + "/FindByMultipleCriteria", 'post', {
                "ID": PatientAppointmentID + "",
                "TableName": enumUtil.enumAPITableName.PATIENTAPPOINTMENTPROCEDURECODE
            }).then((response) => {
                // setIsLoading(false);
                setProcedureCodeData(response.Rows);
            }).catch((error) => {
                // setIsLoading(false);
                setProcedureCodeData([])
            })
        }
    }, [])

    return (
        <div>
            {ProcedurePopup}
            {ModifierPopup}
            <div className='px-3 mt-3 ar_add_appt_type w-100 pb-1-5'>
                <div className="d-flex align-items-center justify-content-between link-header mb-1">
                    <p className="heading">Link Procedure Codes</p>

                    <div className='input claims_info problems-search w-202px'>
                        <i className='icon-Clip-path-group search-icon top-50 translate-middle-y'></i>
                        <SuperICDandCPTSearch
                            type='server'
                            customData={RecentCPTs}
                            id='ProcedureCode'
                            name='ProcedureCode'
                            onChange={handleChangeProcedureCode}
                            getSelectedData={handleSelectData}
                            searchBy={['display', 'Description']}
                            searchValue={ProcedureCode}
                            tableData={[
                                { columName: 'Code', bindingValue: 'display', },
                                { columName: 'Description', bindingValue: 'Description', },
                            ]}
                            ApiLink={API_URL_Claim + "/CPTInstantSearch"}
                            method='post'
                            postBody={cptBody}
                            disabled={true}
                            placeholder={false}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            isItemSelected={!isNull(ProcedureCode) ? true : false}
                            handleAddNewCode={handleAddNewCPT}
                        />
                    </div>
                </div>

                <div className=" hk-expand-table overflow-auto BorderLess-table">
                    <table className='w-100' >
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th className="w-78px">Units</th>
                                <th className="w-78px">Per Unit Amount</th>
                                <th className="w-175px">Modifiers</th>
                                <th className="w-0px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {ProcedureCodeData.length > 0 ?
                                <>
                                    {ProcedureCodeData.map((data, index) => {
                                        return (
                                            <>
                                                {!isNull(data.isDeleted) && data.isDeleted === 'true' ? null : (
                                                    <tr key={index}>
                                                        <td>{data.ProcedureCode}</td>
                                                        <td>
                                                            <div className='input w-100'>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="Units"
                                                                    id="Units"
                                                                    autoComplete="off"
                                                                    onChange={(e) => handleChangeLinkData(e, index)}
                                                                    value={data.Units}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='input w-100'>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="Amount"
                                                                    id="Amount"
                                                                    autoComplete="off"
                                                                    onChange={(e) => handleChangeLinkData(e, index)}
                                                                    value={data.Amount}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='hk-table-flex' >
                                                                <div>
                                                                    <SuperICDandCPTSearch
                                                                        type='server'
                                                                        customData={RecentModifiers}
                                                                        id='Modifier Code'
                                                                        name='ModifierCode1'
                                                                        onChange={(e) => handleChangeLinkData(e, index)}
                                                                        getSelectedData={(singlerow, name, type) => handleSelectLinkData(singlerow, name, type, index)}
                                                                        searchValue={data.ModifierCode1}
                                                                        searchBy={['display', 'Description']}
                                                                        tableData={[
                                                                            { columName: 'Code', bindingValue: 'display', },
                                                                            { columName: 'Description', bindingValue: 'Description', },
                                                                        ]}
                                                                        ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                                                                        method='post'
                                                                        postBody={modifierBody}
                                                                        disabled={true}
                                                                        placeholder={false}
                                                                        sup_btn='sup_btn-Inp'
                                                                        sup_inp='superSearchVisitInp'
                                                                        isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                                                        handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <SuperICDandCPTSearch
                                                                        type='server'
                                                                        customData={RecentModifiers}
                                                                        id='Modifier Code'
                                                                        name='ModifierCode2'
                                                                        onChange={(e) => handleChangeLinkData(e, index)}
                                                                        getSelectedData={(singlerow, name, type) => handleSelectLinkData(singlerow, name, type, index)}
                                                                        searchValue={data.ModifierCode2}
                                                                        searchBy={['display', 'Description']}
                                                                        tableData={[
                                                                            { columName: 'Code', bindingValue: 'display', },
                                                                            { columName: 'Description', bindingValue: 'Description', },
                                                                        ]}
                                                                        ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                                                                        method='post'
                                                                        postBody={modifierBody}
                                                                        disabled={true}
                                                                        placeholder={false}
                                                                        sup_btn='sup_btn-Inp'
                                                                        sup_inp='superSearchVisitInp'
                                                                        isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                                                        handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <SuperICDandCPTSearch
                                                                        type='server'
                                                                        customData={RecentModifiers}
                                                                        id='Modifier Code'
                                                                        name='ModifierCode3'
                                                                        onChange={(e) => handleChangeLinkData(e, index)}
                                                                        getSelectedData={(singlerow, name, type) => handleSelectLinkData(singlerow, name, type, index)}
                                                                        searchValue={data.ModifierCode3}
                                                                        searchBy={['display', 'Description']}
                                                                        tableData={[
                                                                            { columName: 'Code', bindingValue: 'display', },
                                                                            { columName: 'Description', bindingValue: 'Description', },
                                                                        ]}
                                                                        ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                                                                        method='post'
                                                                        postBody={modifierBody}
                                                                        disabled={true}
                                                                        placeholder={false}
                                                                        sup_btn='sup_btn-Inp'
                                                                        sup_inp='superSearchVisitInp'
                                                                        isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                                                        handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <SuperICDandCPTSearch
                                                                        type='server'
                                                                        customData={RecentModifiers}
                                                                        id='Modifier Code'
                                                                        name='ModifierCode4'
                                                                        onChange={(e) => handleChangeLinkData(e, index)}
                                                                        getSelectedData={(singlerow, name, type) => handleSelectLinkData(singlerow, name, type, index)}
                                                                        searchValue={data.ModifierCode4}
                                                                        searchBy={['display', 'Description']}
                                                                        tableData={[
                                                                            { columName: 'Code', bindingValue: 'display', },
                                                                            { columName: 'Description', bindingValue: 'Description', },
                                                                        ]}
                                                                        ApiLink={API_URL_Claim + "/ModifierInstantSearch"}
                                                                        method='post'
                                                                        postBody={modifierBody}
                                                                        disabled={true}
                                                                        placeholder={false}
                                                                        sup_btn='sup_btn-Inp'
                                                                        sup_inp='superSearchVisitInp'
                                                                        isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                                                        handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <i className="icon-x-cros dark-clr fs-20"
                                                                onClick={() => handleDeleteProcedureRow(index)}
                                                            ></i>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )
                                    })}
                                </> : null
                            }

                        </tbody>
                    </table>
                </div>
            </div>
            <div className="tabs-action-bottom mt-2">
                <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-between ar_footer'>
                    {mainAppointmentModal?.Status ?
                        <div className='d-flex align-items-center gap-01'>
                            <p className='text font-m fs-12'>Status:</p>
                            <p className={`heading fs-12 fst-italic ar-status-clm ${String(mainAppointmentModal?.Status).replace(' ', '-')}`}>

                                <div className="app_tooltip bottom grossary description claimStatus">
                                    <p className=' ar-status-clm'>{mainAppointmentModal?.Status}</p>
                                    {!isNull(mainAppointmentModal?.Reason) ? <p className="tool_tip">
                                        <span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={mainAppointmentModal?.Reason}> {mainAppointmentModal?.Reason}</span>
                                    </p> : null}
                                </div>
                            </p>
                        </div> : <div></div>}

                    <div className="d-flex gap-2 align-items-center">
                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => handleAppointmentClose()}>Cancel</button>
                        <button className={IsEditAllowed ? "btn btn-validate px-10 h-100" : "btn btn-validate px-10 h-100 disabled"} onClick={() => handleSaveCPTAppointment()}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNewCPTAppointment